import { useEffect } from 'react';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import JsonLd from '@/components/base/JsonLd';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import StatsSection from './components/StatsSection';
import ResourcesSection from './components/ResourcesSection';
import TestimonialSection from './components/TestimonialSection';
import CTASection from './components/CTASection';
import { SITE_URL } from '@/constants/env';

const websiteJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'OOPBuy Spreadsheet',
  url: SITE_URL,
  description: 'OOPBuy Spreadsheet is your smart product sourcing companion. Explore complete guides, honest reviews, category navigation, and tutorials to streamline your buying workflow.',
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: `${SITE_URL}/?q={search_term_string}`,
    },
    'query-input': 'required name=search_term_string',
  },
  inLanguage: 'en',
};

const organizationJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'OOPBuy Spreadsheet',
  url: SITE_URL,
  description: 'Your trusted resource hub for navigating the OOPBuy Spreadsheet ecosystem. Guides, reviews, tutorials, and category shortcuts for product sourcing.',
  sameAs: [
    'https://kaspreadsheet.com/',
  ],
};

export default function Home() {
  useEffect(() => {
    document.title = 'OOPBuy Spreadsheet – Complete Guide, Reviews & Resources 2026';
  }, []);

  return (
    <div className="min-h-screen bg-background-50">
      <JsonLd data={websiteJsonLd} />
      <JsonLd data={organizationJsonLd} />
      <Header />
      <main>
        <HeroSection />
        <CategoryGrid />
        <StatsSection />
        <ResourcesSection />
        <TestimonialSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}